:host {
  font-family: var(--av-font-family);
  font-size: var(--av-font-size);
  * {
    box-sizing: border-box;
  }
}

.captcha {
  position: absolute;
  bottom: $container-height;
  margin-bottom: 10px;
  .av-card .av-card-body {
    padding: 10px;
  }
}

.av-floating {
  &.av-floating-position-fixed {
    position: fixed;
  }
  &.av-floating-position-custom {
    position: var(--av-floating-position);
    width: $container-width;
    margin-left: var(--av-floating-margin-left);
    margin-right: var(--av-floating-margin-right);
    margin-top: var(--av-floating-margin-top);
    margin-bottom: var(--av-floating-margin-bottom);
  }
  z-index: 100000;

  &.av-floating-top:not(.av-floating-center) {
    &.av-floating-position-fixed {
      top: var(--av-floating-margin-top);
    }
    .av-container.av-container-visible {
      transform: translateY(calc($container-height + 10px)) scale(1);
    }
    .av-tool-container {
      bottom: calc(($container-width + 10px) * -1);
    }
    &.av-floating-mobile {
      // top: 5px;
      .av-container.av-container-visible {
        transform: translateY(0) scale(1);
      }
      .av-tool-container {
        bottom: 0;
      }
    }
  }

  &.av-floating-middle {
    &.av-floating-position-fixed {
      top: calc(50% - $container-height/2);
    }
    .av-container.av-container-visible {
      transform: translateY(calc(($container-height + 10px) * -1)) scale(1);
    }
    .av-tool-container {
      top: calc(($container-width + 10px) * -1);
    }
  }

  &.av-floating-bottom:not(.av-floating-center) {
    &.av-floating-position-fixed {
      bottom: var(--av-floating-margin-bottom);
    }
    .av-container.av-container-visible {
      transform: translateY(calc(($container-height + 10px) * -1)) scale(1);
    }
    .av-tool-container {
      top: calc(($container-width + 10px) * -1);
    }
    &.av-floating-mobile {
      // bottom: 5px;
      .av-container.av-container-visible {
        transform: translateY(0px) scale(1);
      }
      .av-tool-container {
        top: 0;
      }
    }
  }

  &.av-floating-left {
    &.av-floating-position-fixed {
      left: var(--av-floating-margin-left);
    }
    .av-container {
      left: 0;
    }
    .av-tool-container {
      left: calc($container-width * 5 - 10px);
      &:hover {
        transform: translateX(10px);
      }
      &.active {
        transform: translateX(20px);
      }
    }
    &.av-floating-mobile {
      // left: 5px;
      .av-container {
        left: $container-width;
        margin-left: 4px;
      }
    }
  }

  &.av-floating-center {
    &.av-floating-position-fixed {
      left: calc(50% - calc($container-width/2));
    }
    .av-container {
      left: 50%;
      transform: translate(-50%, calc($container-width/2));
      &.av-container-visible {
        transform: translate(-50%, $container-width) scale(1);
      }
    }

    &.av-floating-top {
      &.av-floating-position-fixed {
        top: var(--av-floating-margin-top);
      }
      .av-container-visible {
        top: 10px;
      }
      &.av-floating-mobile {
        .av-container-visible {
          top: 4px;
        }
      }
    }

    &.av-floating-bottom {
      &.av-floating-position-fixed {
        bottom: var(--av-floating-margin-bottom);
      }
      .av-container-visible {
        bottom: calc($container-height * 2);
        margin-bottom: 10px;
      }
      &.av-floating-mobile {
        .av-container-visible {
          margin-bottom: 4px;
        }
      }
    }

    .av-tool-container {
      // right: calc($container-width * 5 - 10px);
      right: 50%;
      margin-right: calc($container-width / 2 + 10px);
      &:hover {
        transform: translateX(-10px);
      }
      &.active {
        transform: translateX(-20px);
      }
    }
  }

  &.av-floating-right {
    &.av-floating-position-fixed {
      right: var(--av-floating-margin-right);
    }
    .av-container {
      right: 0;
    }
    .av-tool-container {
      right: calc($container-width * 5 - 10px);
      &:hover {
        transform: translateX(-10px);
      }
      &.active {
        transform: translateX(-20px);
      }
    }
    &.av-floating-mobile {
      // right: 5px;
      .av-container.av-container-visible {
        right: $container-width;
        margin-right: 4px;
      }
    }
  }
}

@media screen and (max-width: 599px) {
  // .av-floating {
  // right: 20px;
  // bottom: 20px;
  // }
}

@media screen and (min-width: 600px) {
  // .av-floating {
  // right: 50px;
  // bottom: 50px;
  // }
}

.debug {
  position: absolute;
  bottom: $container-height + 10;
  padding: 10px;
}

.blink {
  @include animate(blink, 2s, infinite, linear);
  @include animation-blink();
}

.btn-round {
  border: 0;
  background: transparent;
  width: $container-width;
  height: $container-width;
  border-radius: calc($container-width * 0.5);
  padding: 15px;
  cursor: pointer;
  img {
    width: 100%;
  }
}

.av-container {
  height: $container-width;
  width: $container-width;
  border-radius: calc($container-width * 0.5);
  background-color: var(--av-background-color-tray);
  transition: all 0.4s ease-out;
  z-index: 0;
  position: absolute;
  box-shadow: var(--av-box-shadow-container);
  opacity: 0;
  // right: 0;
  bottom: 0;
  transform: scale(0.2);

  &.av-container-visible {
    z-index: 100020;
    opacity: 1;
    bottom: 0;
  }

  &.av-container-expanded {
    width: calc($container-width * 5);

    .input-container input {
      width: 100%;
    }
  }

  &.av-container-error {
    background-color: var(--av-color-danger);
  }
}

av-asset {
  width: 100%;
}

.input-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  color: var(--av-color-tray);
  padding-left: 6px;
  input {
    color: var(--av-color-tray);
    border: 0;
    background: transparent;
    padding: 15px;
    width: 0;
    border-radius: 25px;
    font-size: 1.1em;
    font-family: var(--av-font-family);
    direction: var(--av-direction);
    transition: width 0.4s ease-out;
    &::placeholder {
      color: var(--av-color-tray);
      opacity: 0.5;
    }
    &:focus {
      outline: none;
    }
  }
  .btn-round {
    background-color: var(--av-color-accent);
    width: calc($container-width - 10px);
    min-width: calc($container-width - 10px);
    height: calc($container-width - 10px);
    margin: 5px;
    padding: calc(var(--av-font-size) * 0.6667); //10px;
    z-index: 100010;
    position: relative;
    &:focus-visible {
      outline-color: var(--av-color-focus-outline);
      outline-offset: 4px;
    }
  }
  av-button {
    transform: scale(0.85);
  }
}

.text-container {
  padding: 10px 20px;
  height: 100%;
  color: var(--av-color-tray);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  direction: var(--av-direction);
  line-height: 1em;
}

.avatar-container {
  padding: 10px;
  height: 100%;
  color: var(--av-color-tray);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  direction: var(--av-direction);
  &.avatar-container-mobile {
    padding: 5px;
  }
}

.spinner-container {
  position: absolute;
  right: -15px;
  transform: translateY(-50%) scale(0.3);
  top: 50%;
  &.spinner-container-inverted {
    left: -10px;
    right: auto;
  }
}

.generic-container {
  height: 100%;
}

.av-tool-container {
  position: absolute;
  transition: transform 0.2s ease-out;
}

.estimated-wait-time {
  text-align: right;
}

.tooltip-container {
  padding: 15px 0;
  position: relative;
  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
    top: -25px;
  }
}

.tooltip {
  @include tooltip;
  right: -20px;
}
